// src/utils/csvParser.js
import Papa from 'papaparse';
import { parse, isValid } from 'date-fns';

export const parseCSV = (file) => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: false, // Don't use headers since they're in a different format
      skipEmptyLines: true,
      complete: (results) => {
        if (results.errors.length) {
          console.error("CSV parsing errors:", results.errors);
          reject(results.errors);
          return;
        }

        // Debug: Log the first few rows of raw data
        console.log("First few rows of raw CSV data:", results.data.slice(0, 3));

        try {
          const parsedData = results.data.map(row => {
            if (row.length !== 2) {
              console.warn("Skipping row due to incorrect format:", row);
              return null;
            }

            const [dateTimeStr, valueStr] = row;
            const rawDateTime = dateTimeStr.trim();
            console.log("Raw date string:", rawDateTime);

            let datetime;

            // Try different date formats
            const dateFormats = [
              'M/d/yy, HH:mm',    // 4/9/25, 00:00
              'd/M/yy, HH:mm',    // 9/4/25, 00:00 (European format)
              'M/d/yy HH:mm',     // 4/9/25 00:00
              'd/M/yy HH:mm',     // 9/4/25 00:00
              'yyyy-MM-dd HH:mm:ss',
              'dd-MM-yyyy HH:mm:ss',
              'yyyy/MM/dd HH:mm:ss',
              'dd/MM/yyyy HH:mm:ss',
              'yyyy-MM-dd HH:mm',
              'dd-MM-yyyy HH:mm',
              'yyyy/MM/dd HH:mm',
              'dd/MM/yyyy HH:mm',
              'M/d/yyyy HH:mm',
              'd/M/yyyy HH:mm'
            ];

            for (const format of dateFormats) {
              datetime = parse(rawDateTime, format, new Date());
              if (isValid(datetime)) {
                console.log("Successfully parsed date:", datetime, "using format:", format);
                break;
              }
            }

            if (!isValid(datetime)) {
              console.warn(`Invalid date format for row: ${rawDateTime}`);
              return null;
            }
            
            const value = parseFloat(valueStr);
            if (isNaN(value)) {
              console.warn(`Invalid value for row: ${valueStr}`);
              return null;
            }

            return { datetime, value };
          }).filter(row => row !== null);

          if (parsedData.length === 0) {
            console.error("No valid data found in CSV file. First few rows:", results.data.slice(0, 3));
            reject([{ message: "No valid data found in CSV file." }]);
            return;
          }

          console.log("Successfully parsed data:", parsedData.slice(0, 3));
          resolve(parsedData);
        } catch (parseError) {
          console.error("Error processing parsed CSV data:", parseError);
          reject([{ message: "Error processing data after parsing.", error: parseError }]);
        }
      },
      error: (error) => {
        console.error("CSV parsing error:", error);
        reject([{ message: "CSV parsing error.", error }]);
      }
    });
  });
};